<app-page-content>
<app-doenkids-menu-bar menuBar> </app-doenkids-menu-bar>

<div content class="newsfeed-container flex-col">
  <div class="news-header justify-start items-center">
    <h1>{{ 'base_news_items.heading' | translate }}</h1>
  </div>
  <p class="description">{{ 'base_news_items.description' | translate }}</p>

  <div class="newsfeed-wrapper">
    <app-newsfeed [organizationUnitId]="1" [isBaseNewsItems]="true" [baseNewsItems]="newsItems$ | async" #newsFeed></app-newsfeed>
  </div>
</div>
<div fixed>
  <router-outlet></router-outlet>
</div>
</app-page-content>
